// extracted by mini-css-extract-plugin
export default {"nav-list":"NavList_nav-list__fE05a","nav-list__item":"NavList_nav-list__item__FToQt"};